// STATS.ips / STATS.customers (see @/lib/constants) are English phrases
// ("Millions of", "thousands"), not numbers — safe to display standalone
// (matches the English page's own stat tiles) but read broken when
// interpolated into a German sentence. These are the German equivalents;
// update them if the underlying constant ever changes to a numeric format
// (e.g. "100M+"), at which point these can be dropped and the English
// constant used directly, same as STATS.countries.
export const STATS_IPS_DE = "Millionen";
export const STATS_CUSTOMERS_DE = "Tausende";
